import React from 'react';

const Footer = ({ decoration = null }) => {

    return (
        <footer className="footer md:min-h-[68px]">
            <div className='vpn-message hidden justify-center text-white font-bold leading-[1.5] mt-[60px] md:flex text-center'>Please ensure VPN is turned on when working from home on an ALDI laptop.</div>
            <div className="container text-center 2xl:flex 2xl:justify-between 2xl:flex-row-reverse py-4 2xl:py-6">
                <div className="social 2xl:min-w-[158px] [&_a::before]:content-[''] flex [&_a]:md:ml-[18px] md:gap-0 gap-4 justify-center mb-[25px] 2xl:mb-[0]">
                    <a className="social-x bg-x-icon block w-[21px] h-[19px]" href="https://x.com/ALDIAustralia" target="_blank" rel="noreferrer"><span className='sr-only'>X icon</span></a>
                    <a className="social-facebook bg-facebook-icon block w-[19px] h-[19px]" href="https://www.facebook.com/ALDI.Australia" target="_blank" rel="noreferrer"><span className='sr-only'>facebook icon</span></a>
                    <a className="social-instagram bg-instagram-icon block w-[19px] h-[19px] " href="https://www.instagram.com/aldiaustralia/?hl=en" target="_blank" rel="noreferrer"><span className='sr-only'>instagram icon</span></a>
                    <a className="social-linkedin bg-linkedin-icon block w-[19px] h-[19px]" href="https://www.linkedin.com/company/aldi-stores-australia/" target="_blank" rel="noreferrer"><span className='sr-only'>linkedin icon</span></a>
                </div>
                <ul className="footer-menu">
                    <li><a href="https://www.aldi.com.au/" target="_blank" rel="noreferrer">ALDI.com.au</a></li>
                    <li><a href="https://www.aldi.com.au/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a></li>
                    <li><a href="https://www.aldi.com.au/data-protection/" target="_blank" rel="noreferrer">Data Protection</a></li>
                    <li><a href="https://www.aldi.com.au/legal-notice/" target="_blank" rel="noreferrer">Legal Notice</a></li>
                    <li><a href="https://security.aldi-sued.com/" target="_blank" rel="noreferrer">Security Policy</a></li>
                    <li><a href="https://www.aldi.com.au/catalogues/" target="_blank" rel="noreferrer">Online Catalogue</a></li>
                </ul>
                <div className="copyright 2xl:min-w-[158px] 2xl:text-left [&_a]:text-white">
                    <span className="text-white font-normal">© 2026 by ALDI</span>
                </div>

            </div>
            {decoration}
        </footer>
    );
};

export default Footer;
